import React from "react";
import "../css/Button.css";
import CuSpinner from "./CuSpinner";

const CustomButton = ({
  children,
  color,
  textColor,
  onClick,
  style,
  className,
  type,
  loading = false,
  disabled = false,
}) => {
  let buttonClassName = "custom-button";
  let buttonStyle = {};
  color = disabled ? "#b4b4b421" : color;

  if (color) {
    buttonClassName += ` ${color}`;
    buttonStyle.backgroundColor = color;
  } else {
    buttonClassName += " primary";
  }

  if (textColor) {
    buttonStyle.color = textColor;
  }

  // Merge the provided styles with dynamically generated styles
  buttonStyle = { ...buttonStyle, ...style };

  return (
    <button
      className={`${buttonClassName} ${className}`}
      style={buttonStyle}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {!loading && children}
      {loading && <CuSpinner />}
    </button>
  );
};

export default CustomButton;
